export async function createPaymentIntent(amountInCents, receiptEmail) {
  const res = await fetch('/api/stripe/create-payment-intent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount: amountInCents, currency: 'usd', receiptEmail })
  })
  if (!res.ok) {
    throw new Error('Failed to create payment intent')
  }
  return await res.json()
}


